// extracted by mini-css-extract-plugin
export default {"projectcontent":"project_projectcontent__WGz0O","h1":"project_h1__oeGcA"};